import DateRangeSetter from './DateRangeSetter';

export default DateRangeSetter;
